var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rules-container"},[_c('Modal',{attrs:{"title":"","scrollable":"","width":"530","class-name":"vertical-center-modal rules-modal"},on:{"on-cancel":_vm.close},model:{value:(_vm.rules),callback:function ($$v) {_vm.rules=$$v},expression:"rules"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.returnData)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86687f66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DeliveryRulesPop.vue
// module id = null
// module chunks = 